import { NavLink, useHistory } from 'react-router-dom'
import styled, { css } from 'styled-components'
import React from "react";
import Badge from "./Badge";
import Avatar from "./assets/MaskGroup.png";
import { cardShadow, hoverEffect, themeColor } from "../utils";
import { useState, useMemo } from "react";
import ShowMore from "react-show-more-button/dist/components/ShowMore";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Rsvp } from "@mui/icons-material";
import axios from "axios";
import { data, error, getJSON } from "jquery";
import { Route } from "react-router-dom";
import { NavHashLink } from 'react-router-hash-link';
import FindPods from "./FindPods";
import Reviewsandratingcandidate from './Reviewsandratingcandidate';
import star from './assets/star.png';
import AWS from 'aws-sdk';
import { FaStar, FaStarHalfAlt } from 'react-icons/fa';
import { AiOutlineStar } from 'react-icons/ai';
import { useTheme } from '@mui/material';
import defaultimg from './assets/defaultimge.png';
import { useAuthToken } from "../TokenContext";
import { useCredentials } from '../useCredentials';
import { useIntl } from 'react-intl';

const ReviewsandratingPodcandidate = () => {
  const { credentials, isLoaded, isLoading, refresh } = useCredentials();
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';

  const S3Config = useMemo(() => ({
    bucketName: credentials.bucketName,
    region: credentials.region,
    accessKeyId: credentials.accessKeyId,
    secretAccessKey: credentials.secretAccessKey
  }), [credentials]);

  const token = useAuthToken();
  const intl = useIntl();
  const { isLoggedIn, user } = useSelector(state => state.auth);
  const [getdata, setGetData] = useState([]);
  const [Starrating, setStarrating] = useState();

  const primaryskill = user.data[0].primaryskill
  const secondaryskill = user.data[0].secondaryskill
  const About = user.data[0].about
  const certification = user.data[0].certification
  const certificationIntitution = user.data[0].certificationInstitution

  const myBucket = new AWS.S3(S3Config);

  function generatePreSignedPutUrl11(picture) {
    const URL_EXPIRATION_TIME = 900;
    var authurl;

    const params = {
      Bucket: process.env.REACT_APP_BUCKETNAME,
      Key: picture,
      Expires: URL_EXPIRATION_TIME,
    }

    myBucket.getSignedUrl('getObject', params, (err, url) => {
      // Handle the signed URL
    });

    return "url";
  }

  useEffect(() => {
    const headers = {
      'Authorization': token,
      'Content-Type': 'application/json',
    };
    const body = { "candidateID": user.data[0].c_id };

    axios.post(process.env.REACT_APP_TALENT_GETPODREVIEW, body, { headers: headers })
      .then((res) => {
        res.data.data.map((result) => {
          setStarrating(result.rating)
        })

        if (res.data.data == "There Are No Reviews.") {
          setGetData([]);
        } else {
          setGetData(res.data.data);
        }
      })
      .catch((err) => {
        console.log("catch", err);
      })
  }, [token]);

  const intervals = [
    { label: 'year', seconds: 31536000 },
    { label: 'month', seconds: 2592000 },
    { label: 'day', seconds: 86400 },
    { label: 'hour', seconds: 3600 },
    { label: 'minute', seconds: 60 },
    { label: 'second', seconds: 1 }
  ];

  function timeSince(date) {
    const seconds = Math.floor((Date.now() - date.getTime()) / 1000);
    const interval = intervals.find(i => i.seconds < seconds);
    const count = Math.floor(seconds / interval.seconds);
    return `${count} ${interval.label}${count !== 1 ? 's' : ''} ago`;
  }

  const ratingStar = Array.from({ length: 5 }, (elem, index) => {
    let number = index + 0.5;
    return (
      <StarIcon key={index} isDarkMode={isDarkMode}>
        {Starrating >= index + 1 ?
          (<FaStar />) : Starrating >= number ? (<FaStarHalfAlt />) : (<AiOutlineStar />)}
      </StarIcon>
    )
  })

  return (
    <Container isDarkMode={isDarkMode}>
      <Header>
        <TitleText isDarkMode={isDarkMode}>
          {intl.formatMessage({ id: 'review' })}
        </TitleText>
        <NavigationTabs>
          <NavTab to='/Reviewsandratingcandidate' isDarkMode={isDarkMode}>
            {intl.formatMessage({ id: 'individual' })}
          </NavTab>
          <NavTabActive to='/ReviewsandratingPodcandidate' isDarkMode={isDarkMode}>
            {intl.formatMessage({ id: 'POD' })}
          </NavTabActive>
        </NavigationTabs>
      </Header>

      <ContentWrapper>
        <ReviewsContainer isDarkMode={isDarkMode}>
          {getdata.length > 0 ?
            getdata.map((item, index) => (
              <ReviewCard key={index} isDarkMode={isDarkMode}>
                <ReviewHeader>
                  <UserInfo>
                    <ProfileImage>
                      {item.profilePicture == null ? (
                        <img
                          src={defaultimg}
                          alt=""
                          style={{ width: 50, height: 50, borderRadius: "50%" }}
                        />
                      ) : (
                        <img
                          src={'https://globldataprod.s3.amazonaws.com/' + item.profilePicture}
                          alt=""
                          style={{ width: 50, height: 50, borderRadius: "50%" }}
                        />
                      )}
                    </ProfileImage>
                    <UserDetails>
                      <UserName isDarkMode={isDarkMode}>
                        {item.podName}
                        <RatingContainer>
                          {ratingStar}
                        </RatingContainer>
                      </UserName>
                      <TimeStamp isDarkMode={isDarkMode}>
                        {timeSince(new Date(item.createdAt))}
                      </TimeStamp>
                    </UserDetails>
                  </UserInfo>
                </ReviewHeader>

                <ReviewDetails isDarkMode={isDarkMode}>
                  <DetailRow>
                    <Label isDarkMode={isDarkMode}>
                      {intl.formatMessage({ id: 'client' })}:
                    </Label>
                    <Value isDarkMode={isDarkMode}>
                      {item.emp_firstname + " " + item.emp_lastname}
                    </Value>
                  </DetailRow>
                </ReviewDetails>

                <ReviewText isDarkMode={isDarkMode}>
                  {item.review}
                </ReviewText>
              </ReviewCard>
            )) : (
              <EmptyState isDarkMode={isDarkMode}>
                <EmptyIcon isDarkMode={isDarkMode}>
                  📝
                </EmptyIcon>
                <EmptyTitle isDarkMode={isDarkMode}>
                  No POD Reviews Yet
                </EmptyTitle>
                <EmptyDescription isDarkMode={isDarkMode}>
                  There are no POD reviews available at the moment. POD reviews will appear here once clients provide feedback.
                </EmptyDescription>
              </EmptyState>
            )}
        </ReviewsContainer>
      </ContentWrapper>
    </Container>
  );
};

// Styled Components with Dark Mode Support
const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
  background-color: ${props => props.isDarkMode ? '#121212' : '#ffffff'};
  min-height: 100vh;
  transition: background-color 0.3s ease;

  @media screen and (max-width: 768px) {
    padding: 1rem;
  }
`;

const Header = styled.div`
  margin-bottom: 2rem;
`;

const TitleText = styled.h1`
  font-size: 2rem;
  font-weight: 700;
  color: ${props => props.isDarkMode ? '#ffffff' : '#2c3e50'};
  margin-bottom: 1.5rem;
  text-align: center;
  
  @media screen and (max-width: 768px) {
    font-size: 1.5rem;
  }
`;

const NavigationTabs = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 2rem;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    gap: 0.5rem;
  }
`;

const navTabBase = css`
  padding: 0.75rem 2rem;
  border-radius: 25px;
  text-decoration: none;
  font-weight: 600;
  transition: all 0.3s ease;
  border: 2px solid transparent;

  @media screen and (max-width: 768px) {
    padding: 0.5rem 1rem;
    text-align: center;
  }
`;

const NavTab = styled(NavLink)`
  ${navTabBase}
  background-color: ${props => props.isDarkMode ? '#2c2c2c' : '#f8f9fa'};
  color: ${props => props.isDarkMode ? '#b0b0b0' : '#6c757d'};
  border-color: ${props => props.isDarkMode ? '#404040' : '#dee2e6'};

  &:hover {
    background-color: ${props => props.isDarkMode ? '#404040' : '#e9ecef'};
    color: ${props => props.isDarkMode ? '#ffffff' : '#495057'};
  }
`;

const NavTabActive = styled(NavLink)`
  ${navTabBase}
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

const ReviewsContainer = styled.div`
  width: 100%;
  max-width: 800px;
`;

const ReviewCard = styled.div`
  background-color: ${props => props.isDarkMode ? '#1e1e1e' : '#ffffff'};
  border-radius: 16px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  border: 1px solid ${props => props.isDarkMode ? '#333333' : '#e9ecef'};
  box-shadow: ${props => props.isDarkMode 
    ? '0 4px 20px rgba(0, 0, 0, 0.3)' 
    : '0 4px 20px rgba(0, 0, 0, 0.08)'};
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: ${props => props.isDarkMode 
      ? '0 8px 30px rgba(0, 0, 0, 0.4)' 
      : '0 8px 30px rgba(0, 0, 0, 0.12)'};
  }

  @media screen and (max-width: 768px) {
    padding: 1rem;
  }
`;

const ReviewHeader = styled.div`
  margin-bottom: 1rem;
`;

const UserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

const ProfileImage = styled.div`
  flex-shrink: 0;
  
  img {
    object-fit: cover;
    border: 3px solid ${props => props.isDarkMode ? '#404040' : '#e9ecef'};
  }
`;

const UserDetails = styled.div`
  flex: 1;
`;

const UserName = styled.h3`
  font-size: 1.1rem;
  font-weight: 600;
  color: ${props => props.isDarkMode ? '#ffffff' : '#2c3e50'};
  margin-bottom: 0.25rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
`;

const TimeStamp = styled.span`
  font-size: 0.875rem;
  color: ${props => props.isDarkMode ? '#b0b0b0' : '#6c757d'};
  font-weight: 500;
`;

const RatingContainer = styled.div`
  display: flex;
  gap: 0.125rem;
`;

const StarIcon = styled.span`
  color: #ffc107;
  font-size: 1rem;
`;

const ReviewDetails = styled.div`
  margin-bottom: 1rem;
`;

const DetailRow = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
  flex-wrap: wrap;
`;

const Label = styled.span`
  font-weight: 600;
  color: ${props => props.isDarkMode ? '#b0b0b0' : '#6c757d'};
  min-width: 80px;
`;

const Value = styled.span`
  color: ${props => props.isDarkMode ? '#ffffff' : '#2c3e50'};
  font-weight: 500;
`;

const ReviewText = styled.p`
  color: ${props => props.isDarkMode ? '#e0e0e0' : '#495057'};
  line-height: 1.6;
  font-size: 1rem;
  margin: 0;
  word-wrap: break-word;
`;

const EmptyState = styled.div`
  text-align: center;
  padding: 4rem 2rem;
  background-color: ${props => props.isDarkMode ? '#1e1e1e' : '#f8f9fa'};
  border-radius: 16px;
  border: 2px dashed ${props => props.isDarkMode ? '#404040' : '#dee2e6'};
`;

const EmptyIcon = styled.div`
  font-size: 3rem;
  margin-bottom: 1rem;
  opacity: 0.6;
`;

const EmptyTitle = styled.h3`
  font-size: 1.25rem;
  font-weight: 600;
  color: ${props => props.isDarkMode ? '#ffffff' : '#2c3e50'};
  margin-bottom: 0.5rem;
`;

const EmptyDescription = styled.p`
  color: ${props => props.isDarkMode ? '#b0b0b0' : '#6c757d'};
  font-size: 1rem;
  line-height: 1.5;
  margin: 0;
  max-width: 400px;
  margin: 0 auto;
`;

export default ReviewsandratingPodcandidate;